
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getBookingSippList } from "../../../../../api/services";
import { FormAutocomplete } from "../../../../../components/fields";
import { ReactQueryKey } from "../../../../../types";
import { IFormValuesBookingsFilter } from "../../../types";

const FormSippList = () => {

    const { t } = useTranslation('booking');

    const sippListQuery = useQuery({
        queryKey: [ReactQueryKey.BookingSippList, {tenants:[],dealers:[]}],
        queryFn: () => getBookingSippList({tenants:[],dealers:[]}),
        enabled: false
    });

    const handleOnOpen = () => {
        if(sippListQuery.data == undefined) 
            sippListQuery.refetch();
    }

    return (
        <FormAutocomplete<IFormValuesBookingsFilter>
            name="sippList"
            label={t('label.sippList')}
            options={sippListQuery.data || []}
            loading={sippListQuery.isLoading}
            multiple
            onOpen={handleOnOpen}
        />
    );
};

export default FormSippList;